import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, LanguageService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from "rxjs/operators";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { GeneralPopupComponent } from "src/app/shared/modules/general-popup/general-popup/general-popup.component";
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { PersonalizationBannerComponent } from "src/app/shared/modules/personalization-banner/personalization-banner.component";
import { BaseService } from "src/app/shared/services/base.service";
import { SharedService } from "src/app/shared/services/shared.service";
import {
  NumberSix,
  NumberTen,
  NumberThree
} from '../../../app/shared/utils/constants/global.constants';
import { CustomInfluenzaService } from "../custom-influenza.service";

@Component({
  selector: 'app-influenza-dashboard',
  templateUrl: './influenza-dashboard.component.html',
  styleUrls: ['./influenza-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfluenzaDashboardComponent implements OnInit, OnDestroy {
  @ViewChildren(NgbPopover) popovers: QueryList<NgbPopover>;
  currentPopover: NgbPopover;
  editMode: boolean = false;
  faxErrorMsg: boolean = false;
  emailErrorMsg: boolean = false;
  cMethodVal: boolean;
  nameErrorMsg: boolean = false;
  addressErrorMsg: boolean = false;
  cityErrorMsg: boolean = false;
  zipErrorMsg: boolean = false;
  phoneErrorMsg: boolean = false;
  selectedUid: any;
  accntId;
  alternativeDataSet: boolean = false;
  subscriptions = new Subscription();
  arrLength: any;
  iscontactMethodThere: boolean = false;
  ordersListCopy: any;
  getActiveLocatorCopy: any;
  fluContactId: any;
  b2bDataSet: any;
  statesArr: Array<any>;
  b2bUnitID: any;
  ordersList: any;
  countofEnrolledStatus: any;
  userData: any = [];
  idofReservation: any;
  waitlistValue: any = 0; //keeping default value as 0
  Enrolled: any;
  userAccountgetData: any;
  getActiveLocator: any;
  isActiveYes: any;
  orderHistory: any = [];
  chosenReservation: any;
  reserveNowClicked = false;
  statusDisplay: any;
  infContact: any;
  activeSeasons: any;
  defaultSeason: any;
  cmsResponse: any;
  fluParagraph: any;
  endDate: any;
  todayDate: Date;
  // displayActiveSeasons = true;
  displaySection: boolean = false;
  startDate: any;
  orderHistorySubscriber: any;
  activeSeaonsSubscriber: any;
  languageUsed: string;
  seasonsList: any;
  modalSubscription: any;
  popupSubscription: any;
  clickedIndex: any;
  dataIndex: any;
  count: number = 0;
  seasonList: any;
  seasonSelected: string;

  baseSiteId: string = 'vsh'; //default val
  fluTimer = 29 * 60 * 1000; //29min
  @ViewChild('ProcessingModal') processingModal;
  processingModalRef: any;
  asmFlag: boolean = false;
  alertMessage: string;
  alertMessageShow: boolean = false;
  prevSelectedSeason: string;

  seasonStsMapping: any = {};
  seasonContractMapping: any = {};
  seasonRuleStatusMapping: any = {};
  userReceivingHours: boolean = false;
  releaseReservation: string = '';
  fluparaStsShipped: any;
  getActiveSeasonDetails: any;
  accountDetails: any;
  showEditCTAShip: boolean = true; // will turn false if line item status is shipped or completed or in process
  notInFormularyMseg: string =
    'This product request is outside your Approved Formulary and can not be ordered at this time. Please talk to your Contract Administrator/Purchasing Department to add products to your Approved Formulary.';
  locationSub: Subscription;
  accountSub: Subscription;
  userAccountDetailsData: any;
  ordersList_2: any;
  hideAll: Observable<boolean>;
  fluLocSub: any;
  recResSub: any;
  recResSub2: any;
  mailErrorMsg: boolean = false;
  constructor(
    private readonly baseService: BaseService,
    private readonly cmsData: CmsService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly user: UserAccountFacade,
    private readonly renderer: Renderer2,
    private readonly ref: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly sharedService: SharedService,
    private readonly languageService: LanguageService,
    private readonly routerr: Router,
    private readonly modal: NgbModal,
    private readonly baseSiteService: BaseSiteService,
    private readonly globalMessage: GlobalMessageService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly customProfService: CustomProfileAndPreferencesService,
    private readonly locService: LoactionStripService
  ) { }

  ngOnInit() {
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userData = res;
        this.influenzaService.getActiveSeasonsFromDb(this.userData.userName);
      }
    });
    this.customProfService.states.subscribe(res => {
      var statesList = res.regions;
      statesList.forEach(element => {
        var statesModified;
        if (element.isocode != '') {
          element.isocodeCopy = element.isocode;
        }
        else {
          element.isocode = element.isocodeCopy;
        }
      });
      this.statesArr = statesList;
    });
    this.hideAll = this.locService.fluDashboardNegativeScenario;

    this.locationSub = this.locService.emitSelectedLocs.pipe(filter(locs => !!locs?.length), take(1)).subscribe(locsData => {
      this.selectedUid = locsData[0].accountNumber;
      this.customProfService.getUserAccountDetailsDataFromDb(this.userData.uid, this.selectedUid);
      this.accountSub = this.customProfService.userAccountDetails.pipe(filter(res => !!res), map(({ res }) => res)).subscribe(response => {
        this.accountDetails = response;
        if (response?.customerSalesAreaData?.deliveryHours?.length > 0) {
          this.userReceivingHours = !response?.customerSalesAreaData?.deliveryHours.some(
            (element) => element.fromTime != 'Closed'
          );
        } else {
          this.userReceivingHours = true;
        }
        this.ref.detectChanges();
      });
      this.initializeOninit(this.userData.uid, this.selectedUid);
    });

    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.releaseReservation = this.activatedRoute.snapshot.queryParams
      .deleteLock
      ? this.activatedRoute.snapshot.queryParams.deleteLock
      : '';
    if (this.releaseReservation !== '') {
      //release lock for the reservation number
      this.releaseLock(this.releaseReservation);
    }
    //asm check - temporary, may remove later
    this.influenzaService.endFluJourneyTimer(); //added for safety, although its happening on verify payment relaese lock
    this.sharedService.removeSessionStorage('isStsEligible');
    this.sharedService.removeSessionStorage('fluEditCta');
    this.sharedService.removeSessionStorage('userFluReceivingHours');
    this.sharedService.removeSessionStorage('fluOnsnCounter');
    this.sharedService.removeSessionStorage('fluDeliveryInfo');
    this.sharedService.removeSessionStorage('dashedit');
    this.sharedService.removeSessionStorage('tempoData');
    this.sharedService.removeSessionStorage('tempoDataInv');
    this.sharedService.removeSessionStorage('fluOrderDtls');
    this.modalSubscription = this.cmsData
      .getContentSlot('SanofiModelWindowSlot')
      .subscribe((res) => {
        if (res?.components[0]?.uid) {
          this.popupSubscription = this.cmsData
            .getComponentData(res.components[0].uid)
            .subscribe((res: any) => {
              if (res?.showPopup === 'true') {
                this.modal.open(PersonalizationBannerComponent, {
                  centered: true,
                  windowClass: 'personalization-banner',
                });
              }
            });
        }
      });
    this.popupSubscription?.unsubscribe();
    this.modalSubscription?.unsubscribe();

    this.languageService.getActive().subscribe((langRes) => {
      this.languageUsed = langRes;
      this.ref.detectChanges();
    });
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.classList.contains('close-banner')) {
        const displayInflunenzaBanner = document.getElementsByClassName(
          'FluParaMiddleSlottop'
        );
        for (let i = 0; i < displayInflunenzaBanner.length; i++) {
          displayInflunenzaBanner[i].className += ' displayNone';
        }
      }
    });


    this.activeSeaonsSubscriber = this.influenzaService.activeSeaons.subscribe(
      (data) => {
        let counter = 0;
        if (data) {
          this.getActiveSeasonDetails = data.categoryData;
          data.categoryData.forEach((season, index) => {
            counter++;
            this.captureStsMapping(
              season?.code,
              season?.isSTSEligible,
              season?.contractLockdown,
              season?.ruleStatus
            );
            this.dataIndex = index;
            season['showAlertMessage'] = false;
            this.seasonsList = data.categoryData;
            this.activeSeasons = season['code'];
            if (season['defaultSeason']) {
              this.seasonSelected = season['code'];
            }
            this.waitlistValue = season['waitlist'];
            this.influenzaService.getUserSeasonWiseOrders(
              this.userData.userName,
              season.code
            );
            this.influenzaService.seasonOrderHistory.subscribe((orderList) => {
              if (Object.keys(orderList).length > 0) {
                if (orderList.code == season.code) {
                  season['ordersList'] = orderList;
                  if (
                    season['defaultSeason'] &&
                    season['ordersList']['orders'] != undefined
                  ) {
                    if (season['ordersList']['orders'].length > 0) {
                      if (orderList.code == this.seasonSelected) {
                        let notConfirmedOrders = orderList['orders'].some(
                          (order) =>
                            order.orderStatus === 'Not confirmed' ||
                            order.orderStatus === 'Partially confirmed' ||
                            order.orderStatus === 'Not Confirmed' ||
                            order.orderStatus === 'Partially Confirmed'
                        );
                        if (notConfirmedOrders) {
                          this.alertMessage = season.alertMessage;
                          this.alertMessage = this.alertMessage.replace(
                            '<p>',
                            "<p class='mb-0'>"
                          );
                          this.alertMessageShow = true;
                          this.prevSelectedSeason = this.seasonSelected;
                        }
                      }
                      season['selectedReservation'] = orderList['orders'][0];
                      let str =
                        orderList['orders'][0]['orderStatus'].toLowerCase();
                      this.statusDisplay =
                        str.charAt(0).toUpperCase() + str.slice(1);
                      this.chosenReservation =
                        orderList['orders'][0]['fluOrderNumber'];
                      this.idofReservation = this.chosenReservation;
                      if (
                        this.statusDisplay == 'Confirmed' ||
                        this.statusDisplay == 'Shipped' ||
                        this.statusDisplay == 'Completed' // this status at order level may or may not come
                      ) {
                        this.influenzaService.getDetailedReservation(
                          this.userData.userName,
                          this.idofReservation,
                          false
                        );
                        //showEdit CTA check for 1st reservation added
                        this.influenzaService.detailedReservation.pipe(take(1))
                          .subscribe((orderDetails) => {
                            orderDetails = this.sharedService.getSessionStorage('fluOverviewData');
                            if (this.statusDisplay.toLowerCase() == 'shipped' ||
                              this.statusDisplay.toLowerCase() == 'completed' ||
                              this.statusDisplay.toLowerCase() == 'confirmed' ||
                              this.statusDisplay.toLowerCase() == 'in process') {
                              if (orderDetails?.consignments?.length > 0
                                && orderDetails?.consignments?.length == orderDetails?.entries.length) {
                                //above && condition added , otherwise sometimes consignments has quite less data than shown in dashbboard shipment table cauisng incorrect results
                                this.showEditCTAShip = orderDetails?.consignments?.every(
                                  (consignment) =>
                                    consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                                    'shipped' ||
                                    consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                                    'completed' ||
                                    consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                                    'in process'
                                )
                                  ? false
                                  : true;
                              } else {
                                this.showEditCTAShip = orderDetails?.entries?.every(
                                  (element) => element?.quantityStatus?.toLowerCase() == 'shipped'
                                    || element?.quantityStatus?.toLowerCase() == 'completed'
                                    || element?.quantityStatus?.toLowerCase() == 'in process'
                                )
                                  ? false
                                  : true;
                              }
                              this.ref.detectChanges();
                            } else if (this.statusDisplay.toLowerCase() == 'confirmed') {
                              this.showEditCTAShip = true;
                              this.ref.detectChanges();
                            }
                          });
                      } else if (this.statusDisplay == 'Partially confirmed') {
                        this.fluParagraph =
                          orderList['partialConfirmedMessage'];
                      } else {
                        this.fluParagraph = orderList['notConfirmedMessage'];
                      }
                      this.ref.detectChanges();
                    }
                  }
                  if (season?.ordersList?.orders && season?.ordersList?.orders?.length > 0) {
                    let shippedOrders = orderList['orders'].filter(
                      (order) =>
                        order?.orderStatus?.toLowerCase() == 'shipped' ||
                        order?.orderStatus?.toLowerCase() == 'completed'
                    );
                    season['allShippedOrders'] = shippedOrders?.length == orderList?.orders?.length ? true : false;
                  }
                }
              }
              if (index == data.categoryData.length - 1) {
                if (data.categoryData[index]) {
                  this.displaySection = true;
                }
                this.ref.detectChanges();
              }
            });
          });
          
          this.ref.detectChanges();
          this.sharedService.setSessionStorage(
            'activeSeasons',
            this.seasonSelected
          );
        }
        this.activeSeaonsSubscriber?.unsubscribe();
      }
    );
    this.customProfService.getStates();
    this.getFluParagraph();
    this.ref.detectChanges();
  }

  initializeOninit(userName, accId) {
    this.influenzaService.getReservationDetails(accId);
    this.influenzaService.getFluLocatorDetails(
      userName,
      accId
    );

    this.fluLocSub = this.influenzaService.fluLocatorDetails.subscribe((resp) => {
      if (resp?.fluLocators != undefined) {
        this.getActiveLocator = JSON.parse(JSON.stringify(resp.fluLocators));
        var checkActiveLocator = this.getActiveLocator.filter(
          (el) => el.statusId != 2
        );

        this.isActiveYes = checkActiveLocator.length > 0 ? 'Active' : 'Inactive';
        this.ref.detectChanges();
        this.fluLocSub?.unsubscribe();
      }
    });

    this.recResSub = this.influenzaService.reservationDetails.subscribe((resp) => {
      if (resp) {
        this.ordersList = JSON.parse(JSON.stringify(resp.influenzaContactInfos));
        this.countofEnrolledStatus = this.ordersList.filter(
          (el) => el.enrollflag == true
        );
        this.countofEnrolledStatus = this.countofEnrolledStatus.length;
        this.Enrolled =
          this.countofEnrolledStatus > 0 ? 'Enrolled' : 'Not Enrolled';
        this.initializeOninit2();
        this.ref.detectChanges();
        this.recResSub?.unsubscribe();
      }
    });
  }

  captureStsMapping(season, stsFlag, contractLockdownFlag, ruleStatusFlag) {
    this.seasonStsMapping[season] = stsFlag ? stsFlag : false;
    this.seasonContractMapping[season] = contractLockdownFlag
      ? contractLockdownFlag
      : false;
    this.seasonRuleStatusMapping[season] = ruleStatusFlag;
  }
  getStsFlag(season) {
    return this.seasonStsMapping[season];
  }
  getContractFlag(season) {
    return this.seasonContractMapping[season];
  }
  getRuleStatusFlag(season) {
    return this.seasonRuleStatusMapping[season];
  }

  isShippingScheduleEnabled() {
    let stsFlag = this.getStsFlag(this.seasonSelected)
      ? this.getStsFlag(this.seasonSelected)
      : false;
    if (stsFlag && this.statusDisplay == 'Confirmed') {
      return true;
    }
    return false;
  }
  manageSts(event) {
    if (event === 'dashboard') {
      this.viewReservation('scheduleShipments');
    }
  }

  releaseLock(releaseReservationNo) {
    const params = {
      requstType: 'UNLOCK', //UNLOCK to unlock
      orderNumber: releaseReservationNo, //this.reservationNo sample - 1092000246
    };
    this.influenzaService
      .fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (res !== null || res !== undefined) {
            const lockStatus = res.mssageType;
            const lockMessage = res.message;
            const lockMessageNo = res.messageNumber;
            if (lockStatus === 'S' && lockMessageNo === '002') {
            } else {
              window.scrollTo(0, 0);
              this.globalMessage.add(
                `Lock could not be released currently for - ${releaseReservationNo} or reservation is not available`,
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        },
        (errors) => {
          window.scrollTo(0, 0);
          this.globalMessage.add(
            errors.message,
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
      );
  }

  ngOnDestroy() {
    this.activeSeaonsSubscriber?.unsubscribe();
    this.orderHistorySubscriber?.unsubscribe();
    this.locationSub?.unsubscribe();
    this.accountSub?.unsubscribe();
    this.recResSub?.unsubscribe();
    this.recResSub2?.unsubscribe();
    this.fluLocSub?.unsubscribe();
    this.sharedService.removeSessionStorage('estimateData');
    this.sharedService.removeSessionStorage('isEditFlu');
  }
  changeReservation(data, seasonCode) {
    this.prevSelectedSeason = this.seasonSelected;
    data !== null
      ? (this.idofReservation = data.fluOrderNumber)
      : (this.idofReservation = this.chosenReservation);
    let str = data !== null ? data?.orderStatus.toLowerCase() : '';
    this.statusDisplay =
      str.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    seasonCode !== null ? (this.seasonSelected = seasonCode) : '';
    if (this.prevSelectedSeason != seasonCode) {
      let arr = this.seasonsList.filter(
        (season) => season.code == this.seasonSelected
      );
      let notConfirmedOrders = arr[0]?.ordersList?.orders.some(
        (order) =>
          order.orderStatus === 'Not confirmed' ||
          order.orderStatus === 'Partially confirmed' ||
          order.orderStatus === 'Not Confirmed' ||
          order.orderStatus === 'Partially Confirmed'
      );
      if (notConfirmedOrders) {
        this.alertMessage = arr[0].alertMessage;
        this.alertMessage = this.alertMessage.replace(
          '<p>',
          "<p class='mb-0'>"
        );
        this.alertMessageShow = true;
      }
    }
    if (data) {
      let notclickedSeasonsList = this.seasonsList.filter(
        (season) => season['code'] != this.seasonSelected
      );
      notclickedSeasonsList.forEach((season) => {
        if (season['ordersList']) {
          season['selectedReservation'] = null;
        }
      });
    }
    if (this.statusDisplay == 'Confirmed' || this.statusDisplay == 'Shipped' || this.statusDisplay == 'Completed') {
      this.influenzaService.getDetailedReservation(
        this.userData.userName,
        this.idofReservation,
        false
      );
      this.influenzaService.detailedReservation.subscribe((orderDetails) => {
        if (this.statusDisplay.toLowerCase() == 'shipped' ||
          this.statusDisplay.toLowerCase() == 'completed' ||
          this.statusDisplay.toLowerCase() == 'confirmed' ||
          this.statusDisplay.toLowerCase() == 'in process'
        ) {
          if (orderDetails?.consignments?.length > 0
            && orderDetails?.consignments?.length == orderDetails?.entries.length) {
            //above && condition added , otherwise sometimes consignments has quite less data than shown in dashbboard shipment table cauisng incorrect results
            this.showEditCTAShip = orderDetails?.consignments?.every(
              (consignment) =>
                consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                'shipped' ||
                consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                'completed' ||
                consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                'in process'
            )
              ? false
              : true;
          } else {
            this.showEditCTAShip = orderDetails?.entries?.every(
              (element) => element?.quantityStatus?.toLowerCase() == 'shipped'
                || element?.quantityStatus?.toLowerCase() == 'completed'
                || element?.quantityStatus?.toLowerCase() == 'in process'
            )
              ? false
              : true;
          }
          this.ref.detectChanges();
        } else if (this.statusDisplay.toLowerCase() == 'confirmed') {
          this.showEditCTAShip = true;
          this.ref.detectChanges();
        }
      });
      //Below if condition only added for STS -shipped scenario
      if (
        this.statusDisplay == 'Shipped' &&
        this.getStsFlag(this.seasonSelected)
      ) {
        let selectedSeasonDetails = this.seasonsList.filter(
          (seasonDetails) => seasonDetails['code'] == this.seasonSelected
        );
        if (selectedSeasonDetails.length > 0) {
          this.fluparaStsShipped =
            selectedSeasonDetails[0]['ordersList']['notConfirmedMessage']; //shippedMessage would be same as notConfirmedMessage
          //hardcoding message for now as shippedMessage is not part of response currently
          //this.fluparaStsShipped ="<div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7 shipments-inactive\"><h3>Check the status of your shipments</h3><p>Once your vaccines are ready to ship, this is where you'll be able to see the status of each shipment and the doses included.</p><p>In the meantime, you can manage your vaccine shipping schedule until <span class=\"bold\">Oct 31, 2022.</span> After that date please call us at 1-800-VACCINE (1-800-822-2463) or contact your Sanofi Pasteur representative.</p></div>";
        }
      }
    } else {
      let selectedSeasonDetails = this.seasonsList.filter(
        (seasonDetails) => seasonDetails['code'] == this.seasonSelected
      );
      if (selectedSeasonDetails.length > 0) {
        if (this.statusDisplay == 'Partially confirmed') {
          this.fluParagraph =
            selectedSeasonDetails[0]['ordersList']['partialConfirmedMessage'];
        } else {
          this.fluParagraph =
            selectedSeasonDetails[0]['ordersList']['notConfirmedMessage'];
        }
      }
    }
    this.ref.detectChanges();
  }
  toggleAlert() {
    this.alertMessageShow = false;
  }
  openReservation() {
    this.routerr.navigate(['/influenza/reservation-overview']);
  }
  viewReservation(actionType: string) {
    this.showHideProcessingModal('show');
    //1. call lock api on both EDIT/VIEW. Need to confirm if to be called on view to lock or not or just show lock popup
    const params = {
      requstType: 'LOCK', //UNLOCK to unlock
      orderNumber: this.idofReservation,
    };
    this.influenzaService
      .fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (res !== null || res !== undefined) {
            const lockStatus = res.mssageType;
            const lockMessageNo = res.messageNumber;

            if (lockStatus === 'S' && lockMessageNo === '003') {
              //start timer -for extend lock scenario
              this.influenzaService.startFluJourneyTimer(this.fluTimer);
              //redirect based on actionType
              if (actionType === 'EDIT') {
                this.redirectToSelectVaccineForEdit();
              } else {
                this.redirectToViewReservationPage(actionType);
              }
            } else if (lockStatus === 'E' && lockMessageNo !== '005') {
              //show lock popup
              this.showFluLockPopup();
            } else {
              //most probably E and 005 - then show message - error fetching order details
              window.scrollTo(0, 0);
              this.globalMessage.add(
                `Reservation Details could not be fetched for order number - ${this.idofReservation}`,
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        },
        (errors) => {
          this.showHideProcessingModal('hide');
          window.scrollTo(0, 0);
          this.globalMessage.add(
            errors.message,
            GlobalMessageType.MSG_TYPE_ERROR
          );
        },
        () => {
          //succ or failure , need to stop loader
          this.showHideProcessingModal('hide');
        }
      );
  }

  showFluLockPopup() {
    const modalRef = this.modal.open(GeneralPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `fluLockModal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.popup_title = 'Reservation Locked';
    modalRef.componentInstance.popup_content =
      'Another user is currently editing this reservation.<br />You will not be able to make changes at this time.';
  }

  showHideProcessingModal(action: string) {
    if (action === 'show') {
      this.processingModalRef = this.modal.open(this.processingModal, {
        centered: true,
        backdrop: 'static',
        windowClass: `processingmodal ${this.baseSiteId}`,
      });
    } else {
      this.processingModalRef.dismiss('closed');
    }
  }

  redirectToSelectVaccineForEdit() {
    if (this.seasonSelected) {
      this.sharedService.setSessionStorage(
        'activeSeasons',
        this.seasonSelected
      );
      const nonConfirmMessage = this.alertMessage ? this.alertMessage : '';
      const reservationStatus = this.statusDisplay ? this.statusDisplay : '';
      this.sharedService.setSessionStorage('alertMessage', nonConfirmMessage);
      this.sharedService.setSessionStorage(
        'reservationStatus',
        reservationStatus
      );
      this.sharedService.setSessionStorage(
        'contractLockdown',
        this.getContractFlag(this.seasonSelected)
      );
      //Setting STS flag before redirecting
      this.asmFlag = this.getStsFlag(this.seasonSelected)
        ? this.getStsFlag(this.seasonSelected)
        : false;
      // this.influenzaService.setShippingSchedule.next(this.asmFlag);
      this.sharedService.setSessionStorage('isStsEligible', this.asmFlag);
    }
    this.router.goByUrl(
      '/fluCategoryPage?editReservation=yes&orderNo=' + this.idofReservation
    );
    this.sharedService.setSessionStorage('dashedit', this.idofReservation);
  }

  redirectToViewReservationPage(requiredTab?) {
    //route to view page
    //this.influenzaService.getDetailedReservation(this.userData.userName, this.idofReservation, true);
    if (this.seasonSelected) {
      this.sharedService.setSessionStorage(
        'activeSeasons',
        this.seasonSelected
      );
      const nonConfirmMessage = this.alertMessage ? this.alertMessage : '';
      const reservationStatus = this.statusDisplay ? this.statusDisplay : '';
      this.sharedService.setSessionStorage('alertMessage', nonConfirmMessage);
      this.sharedService.setSessionStorage(
        'reservationStatus',
        reservationStatus
      );
      this.sharedService.setSessionStorage(
        'contractLockdown',
        this.getContractFlag(this.seasonSelected)
      );
      //Setting STS flag before redirecting
      this.asmFlag = this.getStsFlag(this.seasonSelected)
        ? this.getStsFlag(this.seasonSelected)
        : false;
      // this.influenzaService.setShippingSchedule.next(this.asmFlag);
      this.sharedService.setSessionStorage('isStsEligible', this.asmFlag);
    }
    // this.routerr.navigate(['/influenza/reservation-overview']);
    if (requiredTab && requiredTab === 'scheduleShipments') {
      this.router.goByUrl(
        '/influenza/reservation-overview?scheduleShipments=yes&orderNo=' +
        this.idofReservation
      );
    } else {
      this.router.goByUrl(
        '/influenza/reservation-overview?orderNo=' + this.idofReservation
      );
    }
    //to pass edit cta status
    this.sharedService.setSessionStorage('dashedit', this.idofReservation);
    this.sharedService.setSessionStorage('fluEditCta', this.showEditCTAShip);
    this.sharedService.setSessionStorage('userFluReceivingHours', this.userReceivingHours);
  }
  proceedToCategory(event) {
    this.infContact = event;
  }
  redirecttowaitlist() {
    this.router.goByUrl('/waitlist');
  }
  redirecttoRR(parmas) {
    if (parmas == 'recurring') {
      this.router.goByUrl('/recurringPage');
    }
    if (parmas == 'locator') {
      this.router.goByUrl('/vaccineLocatorPage?referer=influenza/dashboard');
    }
  }
  reserveNow(seasonCode?) {
    if (seasonCode) {
      this.idofReservation = undefined;
      this.statusDisplay = undefined;
      this.seasonSelected = seasonCode;
      this.fluParagraph = this.cmsResponse.content;
      this.sharedService.setSessionStorage('activeSeasons', seasonCode);
      this.sharedService.setSessionStorage(
        'contractLockdown',
        this.getContractFlag(seasonCode)
      );
      //Setting STS flag before redirecting
      this.asmFlag = this.getStsFlag(seasonCode)
        ? this.getStsFlag(seasonCode)
        : false;
      // this.influenzaService.setShippingSchedule.next(this.asmFlag);
      this.sharedService.setSessionStorage('isStsEligible', this.asmFlag);
      this.showNoFluProdError(seasonCode);
    }
  }

  showNoFluProdError(selectedSeason) {
    if (this.accountDetails) {
      if (
        this.accountDetails?.customerSalesAreaData?.formularyCustomer == true
      ) {
        let seasonObj = this.getActiveSeasonDetails.filter(
          (season) => season.code == selectedSeason
        );

        if (seasonObj) {
          let found = seasonObj[0]?.products.some(
            (el) => el.formularyProduct === true
          );
          if (found) {
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            this.router.goByUrl('/fluCategoryPage');
          } else {
            window.scrollTo(0, 0);
            this.globalMessage.add(
              this.notInFormularyMseg,
              GlobalMessageType.MSG_TYPE_ERROR,
              5000000
            );
          }
        }
      } else {
        this.router.goByUrl('/fluCategoryPage');
      }
    }
    else {
      window.scrollTo(0, 0);
      this.globalMessage.add(
        'Account details could not be fetched currently. Please try after sometime.',
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      );
    }
  }
  getFluParagraph() {
    this.cmsData.getComponentData('FluParagraphComponent').subscribe((res) => {
      this.cmsResponse = res;
    });
    if (this.cmsResponse && this.cmsResponse.content) {
      this.fluParagraph = this.cmsResponse.content;
    }
  }

  goToSelectVaccinesPage(seasonCode) {
    if (seasonCode) {
      this.seasonSelected = seasonCode;
      this.sharedService.setSessionStorage('activeSeasons', seasonCode);
      this.router.goByUrl('/fluCategoryPage');
    }
  }

  initializeOninit2() {
    if (this.ordersList.length < 1) {
      this.alternativeDataSet = true;
      this.subscriptions.add(this.locService.emitSelectedLocs$.subscribe(res => {
        this.accntId = res.length ? res[0].accountNumber : JSON.parse(sessionStorage.getItem('defaultLocation'))[0]?.accountNumber;
        this.customProfService.getReccuringReservation(this.accntId);
        this.getReccReservationData();
        this.ref.detectChanges();
      }));
      this.ordersList.forEach(ele => {
        if (!ele.hasOwnProperty("fluContactId")) {
          var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');
          this.customProfService.userAccountDetails.subscribe((userData) => {
            ele.fluContactId = ele.shippingAddresses.accountNumber + "_" + userData?.res?.customerSalesAreaData.salesOrg;
          });
          ele.fullName = ele.locationName;
          // this.iscontactMethodThere = true;
          ele.iscontactMethodThere = true;
          ele.contactMethod = "INT";
        }
        else {
          ele.fullName = (ele?.firstName != undefined ? ele?.firstName : '') + ' ' + (ele?.lastName != undefined ? ele?.lastName : '');
          this.iscontactMethodThere = false;
          ele.iscontactMethodThere = false;
        }
      })
    }
    else {
      this.alternativeDataSet = false;
      this.countofEnrolledStatus = this.ordersList.filter(
        (el) => el.enrollflag == true
      );
      this.countofEnrolledStatus = this.countofEnrolledStatus.length;
      if (this.ordersList != undefined) {
        this.ordersList.forEach((ele) => {

          //if (!ele.hasOwnProperty("email") || !ele.hasOwnProperty("fax")) {
          if (!ele.hasOwnProperty("email") && !ele.hasOwnProperty("fax")) {
            this.getReccReservationData();
          }
          else {
            if (!ele.hasOwnProperty("fluContactId")) {
              var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');
              //this.customProfService.getUserAccountDetailsDataFromDb(usrId, this.accntId);
              this.customProfService.userAccountDetails.subscribe((userData) => {
                this.userAccountDetailsData = userData?.res?.customerSalesAreaData.salesOrg

              });
              ele["fluContactId"] = ele.shippingAddresses.accountNumber + "_" + this.userAccountDetailsData;

              ele.fullName = ele.locationName;
              // this.iscontactMethodThere = true;
              ele.iscontactMethodThere = true;

            }
            else {
              if (ele.hasOwnProperty("firstName")) {
                ele.fullName = (ele?.firstName != undefined ? ele?.firstName : '') + ' ' + (ele?.lastName != undefined ? ele?.lastName : '');
              }
              else {
                ele.fullName = ele.locationName;
              }

              this.iscontactMethodThere = false;
              ele.iscontactMethodThere = false;
            }
          }



          this.ordersList = JSON.parse(JSON.stringify(this.ordersList));
          ele.fullName = ele.firstName + " " + ele.lastName;
        });
        this.arrLength = this.ordersList.length;
        this.ref.detectChanges();
      }
    }
    this.ordersList_2 = JSON.parse(JSON.stringify(this.ordersList));
    this.recResSub2?.unsubscribe();
    //}
    //});

    if (this.getActiveLocator?.length > 0) {
      this.getActiveLocatorCopy = JSON.parse(JSON.stringify(this.getActiveLocator));
      this.getActiveLocator.forEach(el => {
        if (el.hasOwnProperty("fluBlockProductName")) {
          el.isfluBlockProductNameThere = true;
        }
        else {
          el.isfluBlockProductNameThere = false;
        }
        if (el.hasOwnProperty("fluZoneProductName")) {
          el.isfluZoneProductNameThere = true;
        }
        else {
          el.isfluZoneProductNameThere = false;
        }
      })
    }
    if (this.ordersList_2 != undefined) {
      this.ordersList = JSON.parse(JSON.stringify(this.ordersList_2));
    }
  }

  validateEmailmethod(vl) {

    if (vl == '') {
      if (this.cMethodVal != undefined && this.cMethodVal) {
        this.emailErrorMsg = true;
      }

    } else {
      this.emailErrorMsg = false;
      if (!this.validateEmail(vl)) {
        this.mailErrorMsg = true;
      } else {
        this.mailErrorMsg = false;
      }
    }

  }
  validateEmail(emailID) {
    const emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
    //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(emailID)) {
    if (emailRegx.test(emailID)) {
      return true;
    }
    return false;
  }
  cMethodElection(method, val) {
    if (method == 'INT') {
      if (val == '') {
        this.emailErrorMsg = true;
      }
      else {
        this.emailErrorMsg = false;
        this.cMethodVal = true;
        this.faxErrorMsg = false;
      }

    } else {
      if (val == '') {
        this.faxErrorMsg = true;
      }
      else {
        this.faxErrorMsg = false;
        this.cMethodVal = false;
        this.emailErrorMsg = false;
      }
    }
  }

  changeEnrollFlag(id, flag) {
    var obj = {};
    var objSet = {};
    this.ordersList.forEach((ele) => {
      if (ele.fluContactId == id) {
        ele.enrollflag = flag;
        objSet = {
          influenzaContactInfos: [ele],
        };
      }
    });

    this.countofEnrolledStatus = this.ordersList.filter(
      (el) => el.enrollflag == true
    );
    this.countofEnrolledStatus = this.countofEnrolledStatus.length;

  }

  changeEnrollFlag_locator(id, flag, type) {
    var obj = {};
    var objSet = {};
    this.getActiveLocator.forEach((ele) => {

      if (type == 'status') {
        if (ele.operId == id) {
          if (!flag) {
            ele.statusId = 2;
          }
          else {
            ele.statusId = 1;
          }


          objSet = {
            influenzaContactInfos: [ele],
          };
        }
      }
      if (type == 'fluBlok') {
        if (ele.fluBlockProductId == id) {
          if (!flag) {
            ele.fluBlockOptedIn = 'Not Offered';
          }
          else {
            ele.fluBlockOptedIn = 'Offered';
          }

        }
      }

      if (type == 'fluzone') {
        if (ele.fluZoneProductId == id) {
          if (!flag) {
            ele.fluZoneOptedIn = 'Not Offered';
          }
          else {
            ele.fluZoneOptedIn = 'Offered';
          }

        }
      }

    });
    this.countofEnrolledStatus = this.getActiveLocator.filter(
      (el) => el.statusId == true
    );
    this.countofEnrolledStatus = this.countofEnrolledStatus.length;

  }

  reload() {
    this.ordersList = this.ordersListCopy;
  }
  numberValidation(nameVal, type) {
    if (nameVal == '') {
      if (type == 'phone') {
        this.phoneErrorMsg = true;
      }
      if (type == 'zip') {
        this.zipErrorMsg = true;
      }
      return;
    }
    else {
      if (type == 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type == 'zip') {
        this.zipErrorMsg = false;
      }
      if (/^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$/.test(nameVal)) {
      } else {
        return;
      }
    }

  }
  cancelEditSection() {
    this.editMode = false;
    if (this.getActiveLocatorCopy?.length > 0) {
      this.getActiveLocator = JSON.parse(JSON.stringify(this.getActiveLocatorCopy));
    }
    this.currentPopover.close();
  }
  togglePopover(popover, refer) {
    this.ordersList.forEach(el => {
      if (el.fullName == '') {
        el.fullName = el.firstName + " " + el.lastName;
      }
      this.cMethodVal = el.contactMethod == 'INT' ? true : false;
    })
    if (refer == 'locator') {
      if (this.getActiveLocator != undefined) {
        this.getActiveLocator.forEach(el => {
          if (!el?.state?.includes('US-')) {
            el.state = "US-" + el.state;
          }
        });
        this.getActiveLocatorCopy = JSON.parse(JSON.stringify(this.getActiveLocator));
      }
    }

    if (popover !== undefined) {
      this.currentPopover = popover;
    }
    if (this.currentPopover.isOpen()) {
      this.currentPopover.close();
    } else {
      this.currentPopover.open();
    }
  }
  editModeOn() {
    this.editMode = !this.editMode;
  }
  nameValidation(nameVal, type) {
    if (type == 'name') {
      if (nameVal == '') {
        this.nameErrorMsg = true;
      } else {
        this.nameErrorMsg = false;
      }
    }
    if (type == 'address') {
      if (nameVal == '') {
        this.addressErrorMsg = true;
      } else {
        this.addressErrorMsg = false;
      }
    }
    if (type == 'phone') {
      if (nameVal == '') {
        this.phoneErrorMsg = true;
      } else {
        this.phoneErrorMsg = false;
      }
    }
    if (type == 'city') {
      if (nameVal == '') {
        this.cityErrorMsg = true;
      } else {
        this.cityErrorMsg = false;
      }
    }
    if (type == 'zip') {
      if (nameVal == '') {
        this.zipErrorMsg = true;
      } else {
        this.zipErrorMsg = false;
      }
    }


  }
  validateFaxNumber(event, type, id) {
    if (event == '' || event.length < 10) {
      if (this.cMethodVal != undefined && !this.cMethodVal) {
        if (type == 'fax') {
          this.faxErrorMsg = true;
        }
      }
    } else {
      if (type == 'fax') {
        this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      let newVal = event.replace(/\D/g, '');
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= NumberThree) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= NumberSix) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal.length <= NumberTen) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      } else {
        newVal = newVal.substring(0, NumberTen);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;

      this.ordersList.forEach((el) => {
        if (type == 'phone') {
          if (el.operId == id) {
            el.phoneNo = newVal;
          }
        }

        else {
          if (el.fluContactId == id) {
            el.fax = newVal;
          }
        }

      });
    }
  }

  validateFaxNumber_locator(event, type, id) {
    if (event == '' || event.length < 10) {
      if (type == 'phone') {
        this.phoneErrorMsg = true;
      }
      if (this.cMethodVal != undefined && !this.cMethodVal) {
        if (type == 'fax') {
          this.faxErrorMsg = true;
        }
      }

    } else {
      if (type == 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type == 'fax') {
        this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      let newVal = event.replace(/\D/g, '');
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= NumberThree) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= NumberSix) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal.length <= NumberTen) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      } else {
        newVal = newVal.substring(0, NumberTen);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;

      this.getActiveLocator.forEach((el) => {
        if (type == 'phone') {
          if (el.operId == id) {
            el.phone = newVal;
          }
        }

        else {
          if (el.fluContactId == id) {
            el.fax = newVal;
          }
        }

      });
    }
  }
  SaveAction() {
    const splitIndex = this.ordersList[0].fullName.indexOf(" ");  //first space index
    const firstName = this.ordersList[0].fullName.substring(0, splitIndex); //name till 1st space
    const lastName = this.ordersList[0].fullName.substring(splitIndex + 1);
    var obj = {
      enrollflag: false,
      influenzaContactInfos: [
        {
          contactMethod: this.cMethodVal ? 'INT' : 'fax',
          //contactMethod: this.ordersList[0]?.contactMethod ? 'INT' : 'fax',
          email: this.ordersList[0].email,
          enrollflag: this.ordersList[0].enrollflag ? true : false,
          fax: this.ordersList[0].fax != undefined ? this.ordersList[0].fax : '',
          firstName: firstName,
          fluContactId: this.ordersList[0].fluContactId,
          lastName: lastName,
          locationName: this.ordersList[0].locationName,
          // phoneNo: this.ordersList[0].phoneNo,
          phoneNo: this.ordersList[0]?.phoneNo != undefined ? this.ordersList[0]?.phoneNo : '',
          shippingAddresses: this.ordersList[0].shippingAddresses,
        },
      ],
    };
    this.influenzaService.saveReservationDetails(this.b2bUnitID, obj);
    this.influenzaService.reservationDetailsSave.subscribe((res) => {
      if (res.status == 'success') {
        this.cancelEditSection();
        this.initializeOninit(this.userData.uid, this.selectedUid);
        this.globalMessage.add(
          'Reservation contact details updated successfully.',
          GlobalMessageType.MSG_TYPE_CONFIRMATION, 1000
        );
      }
    });
  }

  SaveAction_locator() {
    if (this.getActiveLocator[0].state.isocode != undefined) {
      if (this.getActiveLocator[0].state.isocode.includes("US-")) {
        let stateValue = this.getActiveLocator[0].state.isocode.split("-");
        this.getActiveLocator[0].state.isocode = stateValue[1];
      }
    }
    else {
      if (this.getActiveLocator[0].state.includes("US-")) {
        let stateValue = this.getActiveLocator[0].state.split("-");
        this.getActiveLocator[0].state = stateValue[1];
      }
    }
    var obj = {
      "customerName": this.getActiveLocator[0].customerName,
      "locatorId": this.getActiveLocator[0].locatorId,
      "address": this.getActiveLocator[0].address,
      "city": this.getActiveLocator[0].city,
      "state": this.getActiveLocator[0].state.isocode != undefined ? this.getActiveLocator[0].state.isocode : this.getActiveLocator[0].state,
      "zipcode": this.getActiveLocator[0].zipcode,
      "originalZipcode": this.getActiveLocator[0].zipcode,
      "phone": this.getActiveLocator[0].phone,
      "fax": "",
      "email": "",
      "statusId": this.getActiveLocator[0].statusId,
      "materialOptoutStatusList": [
        {
          "material": this.getActiveLocator[0].fluBlockProductId,
          "optOut": this.getActiveLocator[0].fluBlockOptedIn == 'Not Offered' ? 1 : 0,
          "originalOptOut": this.getActiveLocator[0].fluBlockOptedInCopy == 'Not Offered' ? 1 : 0
        },
        {
          "material": this.getActiveLocator[0].fluZoneProductId,
          "optOut": this.getActiveLocator[0].fluZoneOptedIn == 'Not Offered' ? 1 : 0,
          "originalOptOut": this.getActiveLocator[0].fluZoneOptedInCopy == 'Not Offered' ? 1 : 0
        }
      ],
      "operId": this.getActiveLocator[0].operId,
      "bypassMaterialEnrollment": 0,
      "materialsEnrolled": "",
      "materialsOptedIn": "",
      "showNotOfferedAlert": true,
    };

    this.influenzaService.saveFluLocatorDetails(this.userData.uid, obj)
    this.influenzaService.flulocatorDetailsSave.subscribe((res) => {
      if (res.success) {
        this.cancelEditSection();
        this.initializeOninit(this.userData.uid, this.selectedUid);
        this.globalMessage.add(
          'Vaccine locator details updated successfully.',
          GlobalMessageType.MSG_TYPE_CONFIRMATION, 1000
        );
      }
    });
  }
  getReccReservationData(): void {

    var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');
    //this.customProfService.getUserAccountDetailsDataFromDb(usrId, this.selectedUid);
    this.customProfService.userAccountDetails.subscribe((userData) => {

      var obj_toPush = {};
      if (userData != "") {
        obj_toPush["locationName"] = userData?.res?.locName;
        obj_toPush["fluContactId"] = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;
        obj_toPush["fullName"] = userData?.res?.accountAddress.facilityName;
        obj_toPush["contactMethod"] = 'INT';
        obj_toPush["email"] = userData?.res?.customerSalesAreaData.email;
        obj_toPush["contactEmail"] = true;
        //added for fax disable rule
        obj_toPush["showFax"] = true;

        var obj_payerAddress = {};
        var obj_shppingAddressesCountry = {};
        obj_payerAddress["line1"] = userData?.res?.payerAddress.line1;
        obj_payerAddress["town"] = userData?.res?.payerAddress.town;
        obj_payerAddress["postalCode"] = userData?.res?.payerAddress.postalCode;
        obj_payerAddress["country"] = userData?.res?.payerAddress.country;
        obj_toPush["shippingAddresses"] = userData?.res?.payerAddress;


        this.ordersList = [];
        this.ordersList.push(obj_toPush);
      }

      this.fluContactId = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;
      this.ref.detectChanges();
    })
  }

  openTooltip(tooltip, greeting: string) {
    tooltip.open({ greeting });
  }
  closeTooltip(tooltip) {
    tooltip.close();
  }

}
